/* @ngInject */
function ProductsController ($rootScope, $scope, $q, $translate, $timeout, UdsModalService, ProductsFrameService, ToastService) {
  const getAddProductStepByStepDialogController = () => $q.when(import('../../dialogs/add-product-step-by-step/add-product-step-by-step.controller'))
  const getAddProductDialogController = () => $q.when(import('../../dialogs/add-product/add-product.controller'))

  $scope.products = []
  $scope.cacheProducts = []

  $scope.totalCount = 0
  $scope.currentPage = 1

  $scope.params = {
    $sort: 'externalId',
    $order: 'desc',
    top: 8,
    skip: 0,
    search: ''
  }

  $scope.flags = {
    loading: false,
    hasProducts: false
  }

  $scope.headerNavigation = null
  $scope.headerToolbar = null

  $scope.pageTitle = ''

  const api = {
    getAddProductStepByStepDialogController,
    getAddProductDialogController,
    _onSearch,
    _addProduct,
    _addProductByStep,
    _getProducts,
    _handleGetProducts,
    _getProductsError,
    _getProductsFinally
  }

  this.getApi = () => api

  activate()
  function activate () {
    api._getProducts(true)
  }

  const deregisterRefreshProducts = $rootScope.$on('productsFrame.refresh', () => {
    api._getProducts(true)
  })

  $scope.$on('$destroy', () => {
    deregisterRefreshProducts()
  })

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('productFrame.title')

    $scope.headerToolbar = {
      rightButtons: [{
        type: 'button',
        btnType: 'primary',
        icon: 'plus',
        label: $translate.instant('productFrame.add'),
        onClick: $scope.addProduct
      }],
      search: {
        onSearch: api._onSearch
      }
    }
  })

  $scope.addProduct = () => {
    const hasProducts = $scope.flags.hasProducts

    if (hasProducts) {
      return api._addProduct()
    }

    return api._addProductByStep()
  }

  $scope.getEmptyTitleText = () => {
    if ($scope.params.search) {
      return $translate.instant('productFrame.emptySearch.title')
    }

    return $translate.instant('productFrame.emptyMode.title')
  }

  $scope.getEmptyDescriptionText = () => {
    if ($scope.params.search) {
      return $translate.instant('productFrame.emptySearch.description')
    }

    return $translate.instant('productFrame.emptyMode.description')
  }

  $scope.getProducts = api._getProducts

  $scope.onPagination = (event) => {
    $scope.currentPage = event.detail.currentPage
    $scope.params.skip = ($scope.currentPage - 1) * $scope.params.top
    api._getProducts()
  }

  function _onSearch (search) {
    $scope.params.search = search
    $scope.currentPage = 1
    $scope.params.skip = 0
    api._getProducts()
  }

  function _addProduct () {
    api.getAddProductDialogController().then(({ AddProductDialogController }) => {
      const addProductDialog = UdsModalService.createModal({
        controller: AddProductDialogController,
        modalName: 'addProductDialog'
      })
      addProductDialog.open()
    })
  }

  function _addProductByStep () {
    api.getAddProductStepByStepDialogController().then(({ AddProductStepByStepDialogController }) => {
      const addProductStepByStepDialog = UdsModalService.createModal({
        controller: AddProductStepByStepDialogController,
        modalName: 'addProductStepByStepDialog'
      })
      addProductStepByStepDialog.open()
    })
  }

  async function _getProducts (firstLoad = false) {
    try {
      await api._handleGetProducts(firstLoad)
    } catch (error) {
      api._getProductsError(error)
    } finally {
      api._getProductsFinally()
    }
  }

  async function _handleGetProducts (firstLoad) {
    $scope.flags.loading = true

    const response = await ProductsFrameService.getProducts($scope.params)

    $scope.products = response.rows
    $scope.totalCount = response.count

    if (firstLoad) {
      $scope.flags.hasProducts = !!$scope.products.length
    }
  }

  function _getProductsError (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  function _getProductsFinally () {
    $timeout(() => {
      $scope.flags.loading = false
    })
  }
}

export { ProductsController }
